import { Sliders } from "lucide-react";
import type { ModuleSpec } from "../types";

export const accountSettingsSpec: ModuleSpec = {
  id: "account-settings",
  icon: Sliders,
  i18n: {
    namespace: "modules",
    titleKey: "accountSettings.title",
    descriptionKey: "accountSettings.description",
  },
  nav: {
    path: "/account/settings",
    group: "account",
    order: 40,
  },
  meta: {
    status: "active",
    description: "Account configuration",
  },
};
